import { render, staticRenderFns } from "./AllInOneRegistration.vue?vue&type=template&id=288e1609&scoped=true"
import script from "./AllInOneRegistration.vue?vue&type=script&lang=js"
export * from "./AllInOneRegistration.vue?vue&type=script&lang=js"
import style0 from "./AllInOneRegistration.vue?vue&type=style&index=0&id=288e1609&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "288e1609",
  null
  
)

export default component.exports